module.exports = __webpack_public_path__ + "img/INCNT-alt.2c9081f3.svg";